import {
  Badge as MantineBadge,
  type BadgeProps as MantineBadgeProps,
} from "@mantine/core";
import type { CoreComponentProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export type BadgeProps = CoreComponentProps<MantineBadgeProps, 'div'>;

export function Badge({ testId, view = "all", ...rest }: BadgeProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineBadge data-testid={testId} {...rest} />;
}
